import Vue from 'vue';
import Router from 'vue-router';
// import inner from '../views/inner1'; //（线上绿色sdk）
// import inner from '../views/inner2'; //（线上紫色sdk）
// import inner from '../views/inner3'; //在此版本上做优化
// import inner from '../views/inner4';
// import inner from '../views/inner5'; //2022-05新sdk，尝试template和js分离 公共样式抽离在view5/home中
// import inner from '../views/inner6'; //2022-09 新主题，
// import inner from '../views/inner7'; //2022-09 新主题，
// import inner from '../views/inner8'; //2023-03 新主题，（最新改版橙色主题  使用中）
// import inner from '../views/inner9'; //小游戏，
import inner from '../views/inner10';//2024-05 新主题，（最新改版绿色主题  使用中）
// inner4：做新功能的临时存储
// 1、home组件设置开关，init接口返回数据后在开启home组件
// 2、iframe设置游戏背景
// 功能启用后会清除inner4

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'inner',
      component: inner
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js